<button
  [mdePopoverTriggerFor]="createPopover"
  class="add-template"
  color="primary"
  mat-stroked-button
  mdePopoverTriggerOn="click">
  {{ 'QUERY_BUILDER.save_template' | translate }}
  <mat-icon>bookmarks</mat-icon>
</button>

<mde-popover
    #createPopover="mdePopover"
    [mdePopoverCloseOnClick]="false"
    [mdePopoverOverlapTrigger]="false"
    mdePopoverPositionY="below">
  <mat-card appearance="outlined">
    <mat-card-content>

      <form class="filter-create-form">
        <mat-form-field>
          <mat-label>{{ 'QUERY_BUILDER.name' | translate }}</mat-label>
          <input #nameInput matInput [placeholder]="'QUERY_BUILDER.enter_name' | translate">
        </mat-form-field>
        <div>
          <button (click)="createPopover.close.emit()" color="warn" mat-button>
            {{ 'COMMON.cancel' | translate }}
          </button>
          <button (click)="create(nameInput.value); createPopover.close.emit()"
                  [disabled]="!nameInput.value"
                  color="primary"
                  mat-button
                  type="button">
            {{ 'COMMON.save' | translate }}
          </button>
        </div>
      </form>

    </mat-card-content>
  </mat-card>
</mde-popover>
